import { useMutation } from '@tanstack/react-query';

import service_studies from 'services/studies';

/**
 * @typedef {Object} UseDeleteStudyIntegrationMutationVariables
 * @property {number} studyId
 * @property {number} integrationId
 */

/** @typedef {Omit<import('@tanstack/react-query').UseMutationOptions<void, Error, UseDeleteStudyIntegrationMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseDeleteStudyIntegrationMutationOptions */

/**
 * Delete a study integration (e.g., unlink Dscout study).
 *
 * @param {UseDeleteStudyIntegrationMutationOptions} [options={}]
 */
export const useDeleteStudyIntegrationMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['delete-study-integration'],
        /** @param {UseDeleteStudyIntegrationMutationVariables} payload */
        mutationFn: ({ studyId, integrationId }) => service_studies.deleteIntegration(studyId, integrationId)
    });
};
